module.exports = __webpack_public_path__ + "static/media/07-fabriziodini-hovercolor.e9568af6.jpg";